import { render } from "./footerShort.vue?vue&type=template&id=860ead0a"
import script from "./footerShort.vue?vue&type=script&lang=js"
export * from "./footerShort.vue?vue&type=script&lang=js"

import "./footerShort.vue?vue&type=style&index=0&id=860ead0a&lang=css"

import exportComponent from "/Users/matjeez/Matjez/Projects/websites/simonkr-feb24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__